import { RootState } from '@modules/App/redux/store';
import { AsyncData } from '@shared/interfaces/asyncData';
import { UserMainData } from '@shared/interfaces/user';

export const userDataSelector = (state: RootState): AsyncData<UserMainData> => state.userPage.userPersonalData;

export const userSelector = (state: RootState): UserMainData | null => state.userPage.userPersonalData.data;

export const zohoIdSelector = (state: RootState): string | undefined => state.userPage.userPersonalData.data?.zohoId;
